module.exports = __webpack_public_path__ + "fonts/dfb2e65929bae8712a8111a8389ccf1d.woff2";